module.exports = __webpack_public_path__ + "static/media/insideout-logo-licht.1fcac01d.svg";